import React, { useState } from 'react';
import { submitEvaluationRequest } from '../services/api';
import './Hero.css';

export default function Hero() {
  const [form, setForm] = useState({ platformName: '', email: '', evaluationType: '' });
  const [status, setStatus] = useState(null); // {type:'success'|'error', msg, confirmationNumber}
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const res = await submitEvaluationRequest(form);
      setStatus({ type: 'success', msg: res.message, confirmationNumber: res.data?.confirmationNumber });
      setForm({ platformName: '', email: '', evaluationType: '' });
    } catch (err) {
      const msg = Array.isArray(err.errors) ? err.errors[0] : 'Something went wrong. Please try again.';
      setStatus({ type: 'error', msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="hero" id="main-content">
      <div className="hero-inner">
        <div className="hero-left">
          <div className="hero-eyebrow">Enterprise AI Evaluation Platform</div>
          <h1>We Are Here to Evaluate,<br />Secure &amp; <u>Trust Your GenAI</u></h1>
          <p className="hero-sub">
            AccuGen is the enterprise-grade platform for evaluating AI chatbot quality,
            detecting vulnerabilities, and ensuring full OWASP LLM Top 10 compliance —
            from a single unified dashboard.
          </p>
          <div className="hero-btns">
            <a href="/contact" className="btn-hero-primary" target="_blank" rel="noreferrer">
              Contact Us →
            </a>
            <a href="#capabilities" className="btn-hero-ghost">Explore Features</a>
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-card">
            <div className="hc-badge">
              <span className="hc-dot" />
              Start Evaluation
            </div>
            <div className="hc-title">Begin Your Assessment</div>
            <div className="hc-sub">Run a full OWASP security evaluation in minutes.</div>
            <form className="hc-form" onSubmit={handleSubmit}>
              <input
                className="hc-input"
                type="text"
                placeholder="Your AI Platform Name"
                value={form.platformName}
                onChange={e => set('platformName', e.target.value)}
                required
              />
              <input
                className="hc-input"
                type="email"
                placeholder="Work Email Address"
                value={form.email}
                onChange={e => set('email', e.target.value)}
                required
              />
              <select
                className="hc-select"
                value={form.evaluationType}
                onChange={e => set('evaluationType', e.target.value)}
              >
                <option value="">Select Evaluation Type</option>
                <option>OWASP LLM Top 10 Security</option>
                <option>Bias &amp; Fairness Detection</option>
                <option>Response Quality Scoring</option>
                <option>Full Compliance Report</option>
              </select>
              {status && (
                <div className={`hc-alert hc-alert-${status.type}`}>
                  {status.msg}
                  {status.confirmationNumber && (
                    <div className="hc-confirm">Ref: <strong>{status.confirmationNumber}</strong></div>
                  )}
                </div>
              )}
              <button type="submit" className="hc-btn" disabled={loading}>
                {loading ? 'Submitting…' : 'Request Evaluation →'}
              </button>
              <div className="hc-note">🔒 Secure. Enterprise-grade. No card required.</div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
